@if (label() !== null) {
  <a [routerLink]="routerLink()" [target]="target()">{{ label() }}</a>
} @else {
  <span class="no-link"></span>
}
